import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCandidateList, deleteProfile, duplicateProfile } from "../api/candidate.api";
import { patchProfile } from "@/pages/profile/employee/sections/api/profile.api";
import type { GetCandidateListParams } from "@/interface/candidate";
import { candidateKeys, STALE_5_MIN } from "@/lib/queryKey";

export const useCandidateList = (params?: GetCandidateListParams) =>
  useQuery({
    queryKey: candidateKeys.list(params),
    queryFn: () => getCandidateList(params),
    ...STALE_5_MIN,
  });

export const useUpdateCandidateStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      employment_status,
    }: {
      id: number | string;
      employment_status: "active" | "inactive";
    }) =>
      patchProfile(id, {
        employment_status: employment_status as "active" | "inactive",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: candidateKeys.all });
    },
  });
};

export const useDeleteCandidate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number | string) => deleteProfile(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: candidateKeys.all });
    },
  });
};

export const useDuplicateCandidate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number | string) => duplicateProfile(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: candidateKeys.all });
    },
  });
};